import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { AuthContext } from '../../AuthContext'

function querystring (name, url = window.location.href) {
  name = name.replace(/[[]]/g, '\\$&')

  const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)', 'i')
  const results = regex.exec(url)

  if (!results) {
    return null
  }
  if (!results[2]) {
    return ''
  }

  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}

class UnauthenticatedRoute extends Component {
  render(){
    const { component: C, props: cProps, ...rest } = this.props
    const { AuthUser} = this.context

    const redirect = querystring('redirect')
    return (
      <Route
        {...rest}
        render={props =>
            AuthUser
            ? <C  {...props} {...cProps} />
            : <Redirect
              to={redirect === '' || redirect === null ? '/' : redirect}
            />}
      />
    )
  }
}

UnauthenticatedRoute.contextType = AuthContext

export default UnauthenticatedRoute